module.exports = __webpack_public_path__ + "static/img/banner_pohone2.438834c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner_pohone2.png
// module id = 78
// module chunks = 1 4